module.exports = __webpack_public_path__ + "static/media/WATERDESCENT.9948f435.pdf";